import { ConditionalWrapper } from "components/base/ConditionalWrapper";
import {
  AtLeastOnePermission,
  RestrictedMakerRealm,
  RestrictedRealmContextProvider,
  RestrictedSolutionRealm,
  SolutionPermission
} from "features/access-management";
import { SolutionKeyProvider } from "features/solution";
import { RestrictedTenantRealm, TenantPermission } from "features/tenant";

type RestrictedTenantViewProps = {
  children: React.ReactNode;
  consumerAllowed?: boolean;
  debug?: boolean;
  requiredSolutionPermissions?: SolutionPermission[];
  requiredTenantPermissions?: TenantPermission[];
};

const RestrictedTenantView: React.FC<RestrictedTenantViewProps> = ({
  children,
  consumerAllowed,
  debug,
  requiredSolutionPermissions,
  requiredTenantPermissions
}) => (
  <ConditionalWrapper
    condition={!consumerAllowed}
    wrapperComponent={RestrictedMakerRealm}
  >
    <RestrictedRealmContextProvider debug={debug}>
      <ConditionalWrapper
        condition={
          requiredTenantPermissions !== undefined &&
          requiredTenantPermissions.length > 0
        }
        wrapperComponent={RestrictedTenantRealm}
        wrapperProps={{
          requiredPermissions:
            requiredTenantPermissions as AtLeastOnePermission<TenantPermission>
        }}
      >
        <SolutionKeyProvider>
          <ConditionalWrapper
            condition={
              requiredSolutionPermissions !== undefined &&
              requiredSolutionPermissions.length > 0
            }
            wrapperComponent={RestrictedSolutionRealm}
            wrapperProps={{
              requiredPermissions:
                requiredSolutionPermissions as AtLeastOnePermission<SolutionPermission>
            }}
          >
            {children}
          </ConditionalWrapper>
        </SolutionKeyProvider>
      </ConditionalWrapper>
    </RestrictedRealmContextProvider>
  </ConditionalWrapper>
);

export default RestrictedTenantView;
